<template>
  <div>
    <div
      class="cta-upgrade tooltip-audio-upgrade-now normal-case"
      :class="popup.length > 0 && `${popup}-popup`"
      v-click-outside="outsideClick"
      :style="leftStyle"
    >
      <div>
        <slot name="tooptip" v-if="$slots.tooptip" />
        <div v-else>
          {{ $i18nPresenter.t("This feature is not available in your current plan.") }}
        </div>
      </div>
      <aha-button class="button-upgrade-now" variant="success" @click="$emit('openPlanUpgradeModal')">
        {{ $i18nPresenter.t('Upgrade') }}
      </aha-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PlanTooltip',
  props: {
    planForFeature: {
      type: String,
      default: 'Pro',
    },
    popup: {
      type: String,
      default: '',
    },
    left: {
      type: String,
      default: '',
    },
  },
  computed: {
    leftStyle() {
      return this.left ? { left: this.left } : {}
    },
  },
  methods: {
    outsideClick() {
      this.$emit('clickOutsideUpgrade')
    },
  },
}

</script>
<style lang="scss" scoped>
.cta-upgrade {
  @apply bg-secondary-100 absolute w-64 p-3 rounded z-50;
  top: 2rem;
  left: calc(50% - 150px);

  font-family: 'Nunito', sans-serif;
  padding-bottom: 16px;
  white-space: normal;

  div,
  span {
    @apply text-base-0 text-sm;
    font-weight: normal!important;
  }

  span {
    @apply font-normal mt-1;
  }
}
.bottom-popup {
  top: 3rem;
  left: calc(50% - 150px);
}
.right-popup{
  left: -10px;
  top: 2rem;
  &.upgrade-arrow_slide {
    left: calc(50% - 8px);
  }
}
.center-popup{
  left: -358%;
}
.left-popup{
  left: -210px;
  top: 2.5rem;
}
.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, var(--tw-bg-opacity)) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 2.1rem;
  //
  //&.upgrade-arrow_presentation {
  //  left: calc(50% - 47px);
  //}

  &.upgrade-arrow_slide {
    left: calc(50% - 97px);
  }
}

.tooltip-audio-upgrade-now {
  .button-upgrade-now {
    margin-top: 16px;
  }
}

.icon-audio-pro {
  &:hover {
    cursor: pointer;
  }

}
</style>
